import React from "react";
import PropTypes from "prop-types";

const YoutubeEmbed = ({ embedId }) => (
  <div className="video-responsive">
    <iframe
      width="853"
      height="480"
      src={`https://www.youtube.com/embed/${embedId}`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
    />
  </div>
);

YoutubeEmbed.propTypes = {
  embedId: PropTypes.string.isRequired
};

export const getYoutubeMovieIDfromURL = (iURL) => {
    let movieID;
    if(iURL?.includes('youtube') || iURL?.includes('youtu.be')){
        var arrURL = iURL.split('/');
        movieID = arrURL[arrURL.length-1];
    }
    return movieID;
}

export const getThumbURLfromProduct = (product) => {
  let imgURL = product.YoutubeLink;
  if (imgURL) {
      const movieID = getYoutubeMovieIDfromURL(imgURL);
      if (movieID) {
          imgURL = `https://img.youtube.com/vi/${movieID}/0.jpg`;
      }
  }
  else {
      imgURL = product.images[0];
  }
  return imgURL;
}

export default YoutubeEmbed;
